import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TagItem from 'components/tag-item';

const TagFilter = ({
  options = [],
  name,
  clearLabel,
  multiselect = false,
  onChange = () => {}
}) => {
  const [clearOption, setClearOption] = useState(
    clearLabel ? { label: clearLabel, value: '' } : null
  );
  const [optionsMap, setOptions] = useState(
    new Map(options.map(o => [o.value, o]))
  );

  useEffect(() => {
    if (clearOption) {
      clearOption.isSelected = ![...optionsMap.values()].find(
        o => o.isSelected
      );
      setClearOption(Object.assign({}, clearOption));
    }
  }, [optionsMap]);

  const refreshOptions = () => {
    setOptions(new Map(optionsMap));
  };

  const handleClearOptionChange = () => {
    for (var option of optionsMap.values()) {
      option.isSelected = false;
    }
    refreshOptions();
    onChange({
      options: [],
      selectedValues: [],
      value: null
    });
  };

  const handleOptionChange = e => {
    var targetOption = optionsMap.get(e.value);
    if (!multiselect && targetOption.isSelected) return;

    targetOption.isSelected = !targetOption.isSelected;
    if (!multiselect && targetOption.isSelected) {
      for (var option of optionsMap.values()) {
        option.isSelected = option === targetOption;
      }
    }
    refreshOptions();
    const options = [...optionsMap.values()];
    const selectedValues = options.filter(o => o.isSelected).map(o => o.value);
    const value = (options.find(o => o.isSelected) || {}).value || null;
    onChange({
      options: options,
      selectedValues: selectedValues,
      value: value
    });
  };

  return (
    <div className="tag-filter">
      <ul className="tag-filter__list">
        {clearOption && (
          <li className="tag-filter__list-item" key="clear-all">
            <TagItem
              onChange={handleClearOptionChange}
              {...clearOption}
              id={name + `-SelectId-0`}
              label={clearLabel}
              isDisabled={clearOption.isSelected && !multiselect}
            />
          </li>
        )}
        {[...optionsMap.values()].map((option, index) => (
          <li className="tag-filter__list-item" key={option.value}>
            <TagItem
              onChange={handleOptionChange}
              {...option}
              id={name + `-SelectId-` + (index + 1)}
              isDisabled={option.isSelected && !multiselect}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

TagFilter.propTypes = {
  name: PropTypes.string.isRequired,
  multiselect: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.exact(TagItem.propTypes)),
  clearLabel: PropTypes.string,
  onChange: PropTypes.func
};

TagFilter.propTypesMeta = {
  multiselect: 'exclude'
};
export default TagFilter;
